export const READ_PROJECTS = 'readProjects'

export const READ_SKILLS = 'readSkills'

export const READ_CONTACTS = 'readContactMethods'
